module.exports = __webpack_public_path__ + "static/media/Kubecon_Horiz.c2c8cf9c.svg";